import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import BulkUploader from './pages/BulkUploader';
import AdminPanel from './pages/AdminPanel';
import LoginPage from './pages/LoginPage';
import DataChecker from './pages/DataChecker';
import DistrictDashboard from './pages/DistrictDashboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.css';
import nectarLogo from './assets/images/Nectar Infotel.png';

function App() {
  // --- AUTHENTICATION HELPERS ---
  const user = JSON.parse(localStorage.getItem('user'));
  const userRole = user ? user.role : null;

  const isAuthenticated = () => userRole !== null;
  const isAdmin = () => userRole === 'admin';
  const isChecker = () => userRole === 'checker';
  const isDistrictAdmin = () => userRole === 'district_admin';
  const isSuperAdmin = () => userRole === 'super_admin';
  const isStateAdmin = () => userRole === 'state_admin'; // ✅ NEW V3 HELPER

  // --- PROTECTED ROUTE WRAPPERS ---
  const ProtectedRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/" />;
  };

  const AdminRoute = ({ children }) => {
    return isAdmin() ? children : <Navigate to="/" />;
  };

  // ✅ UPDATED DASHBOARD ROUTE (Allows State Admin)
  const DashboardRoute = ({ children }) => {
    return (isDistrictAdmin() || isSuperAdmin() || isStateAdmin()) ? children : <Navigate to="/" />;
  };

  const CheckerRoute = ({ children }) => {
    return isChecker() ? children : <Navigate to="/" />;
  };

  // --- STYLES ---
  const brandStyle = { display: 'flex', alignItems: 'center', textDecoration: 'none', cursor: 'pointer' };
  const logoStyle = { height: '40px', marginRight: '10px' };
  const companyNameStyle = { fontSize: '1.5rem', fontWeight: 'bold', color: '#005fff' };

  return (
    <Router>
      <div className="App">
        
        {/* --- NAVBAR --- */}
        {isAuthenticated() && (
           <nav className="navbar" style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 30px', background:'white', boxShadow:'0 2px 5px rgba(0,0,0,0.08)', borderBottom:'1px solid #eee', position:'sticky', top:0, zIndex:1000}}>
              
             {/* Brand Logo */}
             <a href="/" style={brandStyle}>
                <img src={nectarLogo} alt="Nectar Infotel Logo" style={logoStyle} />
                <span style={companyNameStyle}>Nectar Infotel</span>
             </a>
              
             <div className="navbar-links" style={{display:'flex', alignItems:'center', gap:'15px'}}>
                
                {/* 1. Bulk Upload (Only for normal users/admins) */}
                {!isDistrictAdmin() && !isSuperAdmin() && !isStateAdmin() && !isChecker() && (
                  <a href="/upload" className="nav-link" style={{textDecoration:'none', color:'#333', fontWeight:'500', padding:'8px 12px'}}>
                    Bulk Upload
                  </a>
                )}

                {/* 2. Monitoring Dashboard (District/Super/State Admins) */}
                {(isDistrictAdmin() || isSuperAdmin() || isStateAdmin()) && (
                  <a href="/dashboard" className="nav-link" style={{textDecoration:'none', color:'#005fff', fontWeight:'bold', padding:'8px 12px'}}>
                    📊 Monitoring Dashboard
                  </a>
                )}
                
                {/* 3. Admin Panel (Legacy) */}
                {isAdmin() && (
                  <a href="/admin" className="nav-link" style={{textDecoration:'none', color:'#dc3545', fontWeight:'500', padding:'8px 12px'}}>
                    Admin Panel
                  </a>
                )}

                {/* 4. Checker Label */}
                {isChecker() && (
                  <span style={{color: '#6f42c1', fontWeight:'bold', background: '#f3e5f5', padding: '5px 10px', borderRadius: '5px'}}>
                    🕵️‍♂️ Data Checker Mode
                  </span>
                )}

                {/* 5. User Badge */}
                <span style={{fontSize: '12px', background:'#eee', padding:'5px 10px', borderRadius:'15px', color:'#666'}}>
                  {user?.district_name || user?.username || 'User'}
                </span>

                {/* 6. Logout Button */}
                <button 
                  className="nav-link" 
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = '/';
                  }}
                  style={{border: '1px solid #ff4d4d', padding:'6px 15px', background:'none', cursor:'pointer', borderRadius:'5px', color:'#ff4d4d', marginLeft:'10px', fontWeight:'600'}}
                >
                  Logout
                </button>
             </div>
           </nav>
        )}

        <main className="app-main">
          <Routes>
            
            {/* 1. DEFAULT ROUTE (Smart Redirect) */}
            <Route 
              path="/" 
              element={
                isAuthenticated() ? (
                  isSuperAdmin() || isDistrictAdmin() || isStateAdmin() ? <Navigate to="/dashboard" /> :
                  isAdmin() ? <Navigate to="/admin" /> : 
                  isChecker() ? <Navigate to="/checker" /> : 
                  <Navigate to="/upload" />
                ) : (
                  <LoginPage />
                )
              } 
            />

            {/* 2. Monitoring Dashboard Route (V3 Updated) */}
            <Route 
              path="/dashboard" 
              element={
                <DashboardRoute>
                  <DistrictDashboard />
                </DashboardRoute>
              } 
            />

            {/* 3. Bulk Uploader Route */}
            <Route 
              path="/upload" 
              element={
                <ProtectedRoute>
                  <BulkUploader />
                </ProtectedRoute>
              }   
            />
            
            {/* 4. Admin Route */}
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              } 
            />

            {/* 5. Checker Route */}
            <Route 
              path="/checker" 
              element={
                <CheckerRoute>
                  <DataChecker />
                </CheckerRoute>
              } 
            />

            {/* Catch-all Redirect */}
            <Route path="*" element={<Navigate to="/" />} />

          </Routes>
        </main>

      </div>
    </Router>
  );
}

export default App;
